import { render, staticRenderFns } from "./SolicitudBajaSim.vue?vue&type=template&id=4c654111&"
import script from "./SolicitudBajaSim.vue?vue&type=script&lang=ts&"
export * from "./SolicitudBajaSim.vue?vue&type=script&lang=ts&"
import style0 from "./SolicitudBajaSim.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4c654111', component.options)
    } else {
      api.reload('4c654111', component.options)
    }
    module.hot.accept("./SolicitudBajaSim.vue?vue&type=template&id=4c654111&", function () {
      api.rerender('4c654111', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SolicitudBajaSim/SolicitudBajaSim.vue"
export default component.exports